import * as React from 'react';
import { connect } from 'react-redux';
import { getNextStep } from '../../../../actions/claimHistoryActionsV2'
import './ClaimHistoryComponents.css';

class ClaimsTile extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();
    }

    render() {
        return (
            <div className="nopa">
                <p className="claim-title mb-0px">{this.props.claimSubmit.selectedClaim.riskItemType}: {this.props.claimSubmit.selectedClaim.incident }</p>
                <p className="description mb-0px mt-10px">{this.props.claimSubmit.selectedClaim.riskItem}</p>
                <p className="mb-0px mt-10px">Claim no. <b>{this.props.claimSubmit.selectedClaim.claimNumber }</b></p>
                <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                <div className="row noma mb-10px">
                    <div className="col nopa">
                        <p className="mb-0px"><b> {this.props.isClaimStatus ? 'Incident date and time' :'Incident date'} </b></p>
                    </div>
                    <div className="col nopa text-right">
                        <p className="mb-0px"><b>{this.props.claimSubmit.selectedClaim.incidentDate}</b></p>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col nopa">
                        <p className="mb-0"><b>Claim logged</b></p>
                    </div>
                    <div className="">
                        <p className="mb-0 text-right">{this.props.claimSubmit.selectedClaim.claimRegisteredDate}</p>
                    </div>
                </div>
                <hr className={this.props.isClaimStatus ? 'mb-15px mt-15px claims-v2-hr-2px' : ''}/>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimsTile);
